import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { CheckboxComponent } from "../../inputs/checkbox/checkbox.component";

@Component({
  selector: "app-secondary-confirmation-box",
  templateUrl: "./secondary-confirmation-box.component.html",
  imports: [CheckboxComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SecondaryConfirmationBoxComponent implements OnInit {
  title = input.required<string>();
  subtitle = input.required<string>();
  checkboxText = input.required<string>();
  parentForm = input.required<FormGroup<any>>();
  formControlKey = input.required<string>();
  link = input<string | undefined>();
  linkText = input<string | undefined>();

  constructor() {}

  ngOnInit(): void {}
}
